import { lazy } from 'react';
import { RouteRegistry } from './RouteRegistry';

const Login = lazy(() => import('@/pages/auth/Login'));
const Register = lazy(() => import('@/pages/auth/Register'));
const RequestPasswordReset = lazy(() => import('@/pages/auth/RequestPasswordReset'));
const ResetPassword = lazy(() => import('@/pages/auth/ResetPassword'));
const CompleteProfile = lazy(() => import('@/pages/auth/CompleteProfile'));

// Note: AuthenticationGuide moved to Admin (/admin/developer/auth-guide) for security
RouteRegistry.registerCategory({
  name: 'auth',
  order: 2,
  routes: [
    // Root route for auth subdomain redirects to login
    { path: '/', component: Login, layout: 'none', subdomain: 'auth' },
    // 'opt' subdomain included - components call checkAndRedirectToAuth() to SSO redirect to auth.molochain.com
    { path: '/login', component: Login, layout: 'none', subdomain: ['public', 'admin', 'auth', 'mololink', 'opt'] },
    { path: '/register', component: Register, layout: 'none', subdomain: ['public', 'auth', 'mololink', 'opt'] },
    { path: '/forgot-password', component: RequestPasswordReset, layout: 'none', subdomain: ['public', 'admin', 'auth', 'mololink', 'opt'] },
    { path: '/reset-password', component: ResetPassword, layout: 'none', subdomain: ['public', 'admin', 'auth', 'mololink', 'opt'] },
    { path: '/complete-profile', component: CompleteProfile, layout: 'none', requireAuth: true, subdomain: ['public', 'admin', 'auth', 'mololink', 'app', 'opt'] }
  ]
});

export const authRoutes = RouteRegistry.getRoutesByCategory('auth');
